import { analytics } from 'config';
import { onDetailsClickAnalytics } from '../../../analytics/price';

/**
 * Wrapper for details analytics
 * @param {StringToString} object
 */
const fireDetailsAnalytics = ({ id, value }) => {
  const { eventName } = analytics.price.details;
  const productOfferName = analytics.price.details.payloadProperty;

  onDetailsClickAnalytics({
    productId: id,
    [productOfferName]: value,
    eventName,
  });
};

export default fireDetailsAnalytics;
export {
  fireDetailsAnalytics,
};
